import script from "./homePageDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./homePageDetails.vue?vue&type=script&setup=true&lang=js"

import "./homePageDetails.vue?vue&type=style&index=0&id=cc689d14&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc689d14"]])

export default __exports__